import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import isString from "lodash/isString";

const operationVesselApi = AiseaApiFactory.get("operationVessel");

class OperationVesselService {
  /**
   * Operationの船舶一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationVessel[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  async getOperationVessels() {
    return await operationVesselApi.index();
  }

  // : boolean
  /**
   * Checks if the provided object is a valid OperationVessel.
   *
   * @param {any} obj - The object to be checked.
   * @returns {boolean} - Returns true if the object is a valid OperationVessel, otherwise returns false.
   */
  isOperationVessel(
    obj // : any
  ) {
    if (!isObject(obj)) return false;
    return (
      isString(obj.id) &&
      (isNumber(obj.sort_order) || obj.sort_order === null) &&
      (isString(obj.disabled_at) || obj.disabled_at === null) &&
      isNumber(obj.permission_level) &&
      isObject(obj.vessel)
    );
  }
}

export default new OperationVesselService();
